export default __webpack_public_path__ + "68c8fcf0df0d23a8ac544234bd636b05.glb";